import { useQuery } from 'react-query'

import { globalSearchRecentsQueryConfig } from '../../../query-configs'

export const useQueryGlobalSearchRecentItems = () => {
  const { data = [] } = useQuery({
    ...globalSearchRecentsQueryConfig.getRecents(),
  })

  return { recentItems: data }
}
